import{etherUnits as t}from"../../constants/unit.js";import{formatUnits as o}from"./formatUnits.js";function r(r,n="wei"){return o(r,t[n])}export{r as formatEther};
